import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Row, Col, Card, Icon, Table, Button, message, Checkbox, notification } from 'antd'
import moment from 'moment'
import F from '../../Functions'
import axios from 'axios'
import AssignUsersModal from './parts/assign-users-modal'
import UnlinkUserModal from './parts/unlink-user-modal'
import DeleteRSUserModal from './parts/delete-rs-user-modal'
import Pagination from '../../components/pagination'
import { Translate } from 'react-translated'
import Cookies from 'js-cookie'
import { removeHeaderTitle, REVIEWSCHEDULER, VONBOARDER, VONSCHEDULER } from '../../utils/Constants';
import { useBoundStore } from '../../store/useBoundStore';
import { clearSharedDashboardDateState } from '../../utils/clearSharedDashboardDateState';
import CustomAgGridTable from '../../Common-Table/CustomAgGridTable';
import '../../Common-Table/CustomAgGridTable.css';
import CustomHeader from '../../CommonHeader/CustomHeader';

class ManageUsers extends Component {
  state = {
    loading: true,
    users: [],
    unlink_user_modal: false,
    loggedin: this.props.auth.user,
    user: {},
    page: 1,
    total_pages: 0,
    updatedUser: {},
    delete_rs_user_modal: false,
    assign_users_modal: false,
  }
  componentDidMount = () => {
    this.loadUsers(1)
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.location.state !== this.props.location.state) {
      this.loadUsers(1)
    }
  };


  onGridReady = (params) => {
    this.setState({
      gridApi: params.api,
      columnApi: params.columnApi
    });

    const savedState = localStorage.getItem("agGridColumnState");
    if (savedState) {
      params.columnApi.applyColumnState({
        state: JSON.parse(savedState),
        applyOrder: true,
      });
    }
  }

  saveState = (params) => {
    const state = params.columnApi.getColumnState();
    localStorage.setItem("agGridColumnState", JSON.stringify(state));
  }

  switchUser = (user) => {
    localStorage.removeItem("agGridColumnState");
    notification.destroy()
    this.setState({ loading: true })
    removeHeaderTitle();
    axios
      .post('/api/switchuser/' + user.id)
      .then((res) => {
        this.setState({ loading: false })
        if (res.data.success) {
          const user = res.data.user;
          if (user.user_type == VONSCHEDULER || user.user_type == REVIEWSCHEDULER) {
            let dateRange = {
              start_date: "2010-01-01",
              end_date: "2050-01-01",
            };
            useBoundStore.getState().setRSFSCardFilters({
              defaultToggleUserRole: REVIEWSCHEDULER,
              datemodified: dateRange
            });
          } else if (user.user_type == VONBOARDER) {
            useBoundStore.getState().setRSFSCardFilters({ defaultToggleUserRole: VONBOARDER });
          }
          Cookies.set(
            'user_info',
            JSON.stringify({
              first_name: user.first_name,
              last_name: user.last_name,
              email: user.email,
              id: user.id,
              user_type: user.user_type,
              default_date: user.default_date,
              last_login: user.last_login,
              language: user.language,
              active: user.active
            }), {
            secure: true,           //  HTTPS only
            sameSite: 'Lax',        // Add this — fixes the scan finding
            path: '/',              // explicit path
          }
          )
          clearSharedDashboardDateState();
          this.getUser().then(() => {
            this.props.history.push('/dashboard');
            window.location.reload();
          });
        } else {
          message.error(F.translate(`Can't switch to the user.`))
        }
      })
      .catch(() => {
        this.setState({ loading: false })
        message.error(F.translate(`Can't switch to the user.`))
      })
  }


  getUser = () => {
    this.setState({ loading: true });
    return axios.get("/api/user")
      .then((res) => {
        const roleNames = res.data.roles.map(role => role.rolename);
        localStorage.setItem('roles', JSON.stringify(roleNames));
      })
      .catch((error) => {
        console.error("Error fetching user:", error);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };



  // disableUser=(userId)=>{
  //     let data = {
  //         active:0
  //     }

  //     axios.put(`/api/users/${userId}`,data).then((res)=>{
  //         this.setState({
  //             user : res.data
  //         })
  //     }).catch((e)=>{
  //         F.log("error in dsiabling user ",e)
  //     })
  // }
  loadUsers = (page) => {
    const users_list = []
    const historyState = this.props.history.location;
    const api =
      `/api/v1/associations${historyState.state && historyState.state.user_type && historyState.state.user_type !== 'SUPER_ADMIN' ? `?user_type=${historyState.state && historyState.state.user_type}&page=` : '?page='}${page}`

    this.setState({ loading: true })
    if (historyState.state && historyState.state.user_type) {
      this.setState({ loggedin: { ...this.state.loggedin, user_type: historyState.state.user_type, old_user_type: this.state.loggedin.old_user_type ? this.state.loggedin.old_user_type : this.state.loggedin.user_type } }) // NOSONAR
    }

    axios.get(api).then((res) => {
      const users = res.data.objects
      if (users.length > 0) {
        const users_id = []
        for (let i = 0; i < users.length; i++) {
          const u = users[i].child
          u.association_id = users[i].id
          u.user_type2 = u.user_type
          if (u.user_type === 'MORTGAGE_BROKER') {
            u.user_type2 = 'Mortgage Broker'
          }
          if (
            u.jobs &&
            typeof u.jobs !== 'undefined' &&
            u.user_type === 'LSP'
          ) {
            var jobs = JSON.parse(u.jobs)
            if (
              typeof jobs.onboarding !== 'undefined' &&
              typeof jobs.life_licensed !== 'undefined'
            ) {
              if (jobs.onboarding && jobs.life_licensed) {
                u.user_type2 = u.user_type2 + ' (Onboarding & Life Licensed)'
              } else if (jobs.onboarding) {
                u.user_type2 = u.user_type2 + ' (Onboarding)'
              } else if (jobs.life_licensed) {
                u.user_type2 = u.user_type2 + ' (Life Licensed)'
              }
            }
          }
          users_list.push(u)
        }
      }
      this.setState({
        loading: false,
        users: users_list,
        page: res.data.page,
        total_pages: res.data.total_pages,
      })
    })
  }

  updateHiddenStatus = (id, e, status, page) => {
    e.preventDefault()
    // F.log("Id => ",id)
    let api = '/api/users'
    let data = {
      hidden: status,
    }
    axios.put(`${api}/${id}`, data).then((res) => {
      F.log(res.data)
      this.setState({
        updatedUser: res.data,
      })

      // window.location.reload();
    })

    this.loadUsers(page)
  }


  onGridReady = (params) => {
    this.setState({
      gridApi: params.api,
      columnApi: params.columnApi
    });

    const savedState = localStorage.getItem("agGridColumnState");
    if (savedState) {
      params.columnApi.applyColumnState({
        state: JSON.parse(savedState),
        applyOrder: true,
      });
    }
  }

  saveState = (params) => {
    const state = params.columnApi.getColumnState();
    localStorage.setItem("agGridColumnState", JSON.stringify(state));
  }


  render() {
    const { loading, users, page, total_pages } = this.state

    const data = []
    for (let i = 0; i < users.length; i++) {
      let user = users[i]
      F.log('users', user.user_type2)

      data.push({
        key: i,
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        user_type:
          user.user_type2 == 'LSP (Onboarding & Life Licensed)' ||
            user.user_type2 == 'LSP (Life Licensed)' ||
            user.user_type2 == 'LSP (Onboarding)' ||
            user.user_type2 == 'LSP'
            ? 'Agency Staff'
            : user.user_type2 === "VONBOARDER" ? "Follow-Up Specialist" : user.user_type2,
        action: (
          <div className="right-align">
            {/* {user.hidden}
            <Checkbox
              checked={this.state.hidden}
              onChange={(e) => this.setState({ hidden: e.target.checked })}
            >
              <Translate text={`Hide`} />
            </Checkbox> */}

            {F.log('hidden', user.hidden)}
            {this.state.loggedin.user_type === 'AGENCY_OWNER' &&
              (user.hidden ? (
                <Button
                  style={{ marginRight: 10 }}
                  onClick={(e) =>
                    this.updateHiddenStatus(user.id, e, false, page)
                  }
                >
                  {' '}
                  <Translate text={`UnHide User`} />
                </Button>
              ) : (
                <Button
                  style={{ marginRight: 10 }}
                  onClick={(e) =>
                    this.updateHiddenStatus(user.id, e, true, page)
                  }
                >
                  {' '}
                  <Translate text={`Hide User`} />
                </Button>
              ))}
            <Link to={'/manage-users/edit-user/' + user.id}>
              <Button
                className="borderRadius-28"
              >
                <Icon type="edit" /> <Translate text={`Edit User`} />
              </Button>
            </Link>
            {user.user_type === 'MORTGAGE_BROKER' ? (
              <Button
                style={{ marginLeft: 10 }}
                onClick={() => {
                  this.setState({ user, assign_users_modal: true })
                }}
              >
                <Icon type="plus" /> <Translate text={`Assign Users`} />
              </Button>
            ) : null}
            {/*user.user_type !== 'SUPER_ADMIN' ? (
                            <Button style={{ marginLeft: 10 }} type="danger" ghost onClick={() => {
                                this.setState({ user, unlink_user_modal: true })
                            }}>
                                <Icon type="minus" />
                                {user.user_type === 'LSP' ? (
                                    <span><Translate text={`Disable User`} /></span>
                                ) : (
                                    <span><Translate text={`Unlink User`} /></span>
                                )}
                            </Button>
                        ) : null} */}
            {/* Switch to Follow-Up Specialist  */}
            {((this.state.loggedin.id === 2 && this.state.loggedin.user_type === 'EA') || this.state.loggedin.user_type === 'BOBADMIN') ? (
              <Button
                style={{ marginLeft: 10 }}
                onClick={() => this.switchUser(user)}
              >
                <Icon type="sync" />{' '}
                <Translate text={`Switch to Follow-Up Specialist`} />
              </Button>
            ) : null}
            {user.user_type !== 'REVIEWSCHEDULER' ? (
              <Button
                className="borderRadius-28"
                style={{ marginLeft: 10 }}
                type="danger"
                ghost
                onClick={() => {
                  this.setState({ user, unlink_user_modal: true })
                }}
              >
                <Icon type="minus" />
                {user.user_type === 'LSP' ||
                  user.user_type === 'AGENCY_MANAGER' ? (
                  <span>
                    <Translate text={`Disable User`} />
                  </span>
                ) : (
                  <span>
                    <Translate text={`Unlink User`} />
                  </span>
                )}
              </Button>
            ) : null}

            {this.state.loggedin.user_type === 'REVIEWADMIN' ? (
              <Button
                className="borderRadius-28"
                style={{ marginLeft: 10 }}
                onClick={() =>
                  this.setState({
                    user,
                    delete_rs_user_modal: true,
                  })
                }
              >
                <Icon type="edit" /> <Translate text={`Transfer B Files and Agencies`} />
              </Button>
            ) : null}
            {this.state.loggedin.user_type === 'REVIEWADMIN' ? (
              <Button
                style={{ marginLeft: 10 }}
                onClick={() => this.switchUser(user)}
              >
                <Icon type="sync" />{' '}
                <Translate text={`Switch to Review Scheduler`} />
              </Button>
            ) : null}
          </div>
        ),
      })
    }

    // AgGrid column definitions
    const columnDefs = [
      {
        headerClass: 'custom-ag-header',
        headerName: "First Name",
        field: 'first_name',
        minWidth: 200,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['First Name'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'first_name',
        }),
        pinned: 'left',
        suppressHorizontalScroll: false,
        lockPinned: true,
      },
      {
        headerClass: 'custom-ag-header',
        headerName: "Last Name",
        field: 'last_name',
        minWidth: 200,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Last Name'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'last_name',
        }),
        pinned: 'left',
        suppressHorizontalScroll: false,
        lockPinned: true,
      },
      {
        headerClass: 'custom-ag-header',
        headerName: "Email",
        field: 'email',
        minWidth: 250,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Email'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'email',
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.email}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: "User Type",
        field: 'user_type',
        minWidth: 200,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['User Type'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'user_type',
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.user_type}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: "Actions",
        field: 'action',
        minWidth: 350,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Actions'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'action',
        }),
        cellRendererFramework: (params) => (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 8, height: '100%', width: '100%' }}>
            {params.data.action.props.children}
          </div>
        ),
      },
    ];

    return (
      <div>
        <Card
          type="inner"
          title={
            <div style={{ paddingTop: 7 }}>
              <Icon type="team" style={{ marginRight: 10, color: '#1890ff' }} />
              <Translate text={`Users`} />
            </div>
          }
          className="tableCard"
          loading={loading}
        >
          <div
          // style={{ width: '100%', overflowX: 'auto' }}
          >
            <CustomAgGridTable
              onGridReady={this.onGridReady}
              onColumnMoved={this.saveState}
              onSortChanged={this.saveState}
              onFilterChanged={this.saveState}
              rowDatas={data}
              columnDefss={columnDefs}
            // styles={{ minWidth: 1400 }}
            />
          </div>
          <Pagination
            className="pagination-container cpagination"
            current_page={page}
            total_pages={total_pages}
            onClick={(page) => {
              this.loadUsers(page)
            }}
          />
        </Card>
        <UnlinkUserModal
          history={this.props.history}
          showModal={this.state.unlink_user_modal}
          hideModal={() => this.setState({ unlink_user_modal: false })}
          user={this.state.user}
          refresh={() => this.loadUsers(1)}
          loggedin={this.state.loggedin}
        />
        {this.state.delete_rs_user_modal ? (
          <DeleteRSUserModal
            history={this.props.history}
            showModal={this.state.delete_rs_user_modal}
            hideModal={() => this.setState({ delete_rs_user_modal: false })}
            user={this.state.user}
            refresh={() => this.loadUsers(1)}
            loggedin={this.state.loggedin}
          />
        ) : null}
        {this.state.assign_users_modal ? (
          <AssignUsersModal
            history={this.props.history}
            showModal={this.state.assign_users_modal}
            hideModal={() => this.setState({ assign_users_modal: false })}
            user={this.state.user}
            refresh={() => this.loadUsers(1)}
          />
        ) : null}
      </div>
    )
  }
}

export default ManageUsers



// WEBPACK FOOTER //
// ./src/scenes/ManageUsers/index.js